<ion-content class="login --no-bg">
  <div class="login__background"></div>
  <div class="login__content">
    <span class="login__content__title --sign">
      <img src="/assets/emojis/vector.png" alt="" />
      <span [innerHTML]="'We can do anything we want to if we stick to it long enough 🙌'"></span>
    </span>
    <div class="login__content__sign">
      <span class="login__content__sign__text" [innerHTML]="'- Helen Keller'"></span>
      <ion-button class="button --w-icon login__content__sign__button">
        <span [innerHTML]="'weiter'"></span> <ion-icon name="arrow-forward-sharp"></ion-icon>
      </ion-button>
    </div>
  </div>
</ion-content>
